import { conversationService } from '@/modules/conversation/services/conversationService';

const state = {
  counts: 0,
};

const mutations = {
  setCounts(state, value) {
    state.counts = value;
  },
};

const actions = {
  async fetchConversationCounts({ commit }) {
    try {
      const countsValue = await conversationService.getConversationsCounts();
      commit('setCounts', countsValue);
    } catch (error) {
      // Gracefully handle network errors - keep existing count
      console.warn('Failed to fetch conversation counts:', error.message);
      // Don't update state on error - keep the previous value
    }
  },
};

const getters = {
  counts: (state) => state.counts,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
